import { post, parseData } from '../api/common';
import { responseHandler } from '../api/api';
export const getEmployees = (options) => post('/InternalAPI/EmployeeAPI.asmx/GetEmployeesForCurrentCompany', { options })
    .then(parseData)
    .then(responseHandler);
